<template>
	<el-row>
		<el-form :model="info" :rules="infoRules" ref="info" label-position="right" label-width="90px">
			<el-form-item label="课件方向:" prop="direction">
				<el-select size="mini" v-model="info.direction" clearable style="width: 500px">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="课件分类:" prop="category">
				<el-cascader size="mini" v-model="info.category" :options="options2" :props="cateListProps" clearable
					style="width: 500px" />
			</el-form-item>
			<el-form-item label="标题:" prop="courseName">
				<el-input size="mini" placeholder="50字" maxlength="50" v-model="info.courseName" style="width: 300px">
				</el-input>
			</el-form-item>
			<el-form-item label="副标题:">
				<el-input size="mini" placeholder="50字" maxlength="50" v-model="info.courseSubTitle"
					style="width: 300px">
				</el-input>
			</el-form-item>
			<el-form-item label="付费类型:" prop="free">
				<el-radio-group v-model="info.free" @change="xzLx()">
					<el-radio :label="1">付费</el-radio>
					<el-radio :label="0">免费</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="课件价格:" prop="coursePrice" v-if="info.free == 1">
				<div style="display: flex">
					<el-input size="mini" style="width: 200px" v-model="info.coursePrice"></el-input>元
				</div>
			</el-form-item>
			<el-form-item label="付费群体:">
				<el-checkbox-group v-model="info.payGroup">
					<el-checkbox v-for="item in levelList" :key="item.levelCode" :label="item.levelCode">
						{{item.levelName}}
					</el-checkbox>
				</el-checkbox-group>
				<div style="color: #cca771">提示：未选择的则默认免费使用！</div>
			</el-form-item>
			<el-form-item label="课件封面:" prop="themePic">
				<el-button @click="drawer = true" type="primary" size="mini" style="margin-bottom: 10px;">
					图片库上传
				</el-button>
				<el-upload :class="{ hide: true }" :action="uploadUrl" list-type="picture-card" :limit="1"
					:on-success="getPictrueURL" accept=".jpg,.png" :file-list="info.themePic"
					:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeUpload">
					<i class="el-icon-plus" />
				</el-upload>
				<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed">
					<el-image width="100%" :src="dialogImageUrl"></el-image>
				</el-dialog>
				<span>最多上传1张,建议照片比例16:9</span>
			</el-form-item>
			<el-form-item label="课程介绍:" prop="courseIntroduce">
				<wangeditor v-model="info.courseIntroduce" style="width: 900px; margin-right: 800px" />
			</el-form-item>
			<el-form-item>
				<el-button @click="next()" type="primary" style="width: 200px">下一步</el-button>
			</el-form-item>
		</el-form>
		<el-drawer title="图片选择" :visible.sync="drawer" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script type="text/javascript">
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture,
			wangeditor
		},
		data() {
			return {
				drawer: false,
				uploadUrl: httpClient.imgUrl,
				hideUpload: false,
				dialogDisplay: false,
				levelList: [],
				dialogImageUrl: "",
				info: {
					courseName: "", //标题
					courseSubTitle: "", //副标题
					courseIntroduce: "", //课程介绍
					coursePrice: "", //价格
					themePic: [], //图片
					direction: "", //（课程方向ID）
					category: "", //（课程类别ID）
					free: "", //（0免费，1付费）
					payGroup: [], //（存ID好，还是直接存等级好）
					type: "", //（课程来源，0是官方，1是其他）
				},
				infoRules: {
					direction: [{
						required: true,
						trigger: "blur",
						message: "请选择课件方向",
					}, ],
					category: [{
						required: true,
						trigger: "blur",
						message: "请选择课件分类",
					}, ],
					courseName: [{
						required: true,
						trigger: "blur",
						message: "请输入标题",
					}, ],
					free: [{
						required: true,
						trigger: "blur",
						message: "请选择付费类型",
					}, ],
					coursePrice: [{
						required: true,
						trigger: "blur",
						message: "请输入课件价格",
						pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					}, ],
					themePic: [{
						required: true,
						trigger: "blur",
						message: "请上传课件封面",
					}, ],
					courseIntroduce: [{
						required: true,
						trigger: "blur",
						message: "请输入课程介绍",
					}, ],
				},
				options: [],
				options2: [],
				cateListProps: {
					value: "dicId", //匹配响应数据中的id
					label: "dicDesc", //匹配响应数据中的name
					children: "sonDicList", //匹配响应数据中的children
				},
			};
		},
		methods: {
			getImg(e) {
				this.info.themePic = [];
				[e].forEach(item => {
					this.info.themePic.push({
						url: item
					})
				})
				this.drawer = false
			},
			xzLx() {
				if (this.info.free == 0) {
					this.info.coursePrice = 0;
				}
			},
			next() {
				let category = "";
				let payGroup = "";
				if (this.info.category.length > 0) {
					category = this.info.category[1];
				}
				if (this.info.payGroup.length > 0) {
					payGroup = this.info.payGroup.join(",");
				}
				this.$refs.info.validate((valid) => {
					if (valid) {
						this.$http
							.post(`/api/course/clrCourse/addCourse`, {
								courseName: this.info.courseName, //标题
								courseSubTitle: this.info.courseSubTitle, //副标题
								courseIntroduce: this.info.courseIntroduce, //课程介绍
								coursePrice: this.info.coursePrice, //价格
								themePic: this.info.themePic[0].url, //图片
								direction: this.info.direction, //（课程方向ID）
								category: category, //（课程类别ID）
								free: this.info.free, //（0免费，1付费）
								payGroup: payGroup, //（存ID好，还是直接存等级好）
								type: this.info.type, //（课程来源，0是官方，1是其他）
							})
							.then((res) => {
								if (res.data.data) {
									this.$message.success(res.data.msg);
									this.$router.push({
										path: "../viewCourseware",
										query: {
											id: res.data.data,
										},
									});
								} else {
									this.$message.error(res.data.msg);
								}
							});
					}
				});
			},
			//方向
			getInfo1() {
				this.$http
					.get(
						`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=405`, {}
					)
					.then((res) => {
						if (res.data.data.length > 0) {
							res.data.data.forEach((i) => {
								this.options.push({
									label: i.dicDesc,
									value: i.dicId,
								});
							});
						}
					});
			},
			//类别
			getInfo2() {
				this.$http
					.get(
						`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}
					)
					.then((res) => {
						if (res.data.data.length > 0) {
							res.data.data.forEach((i) => {
								if (i.sonDicList == null) {
									i.sonDicList = []
								}
							});
							this.options2 = res.data.data;
						}
					});
			},
			//等级
			getLevel() {
				this.$http.get(`/api/user/userLevel/getLevelDrop`, {}).then((res) => {
					this.levelList = res.data.data
				})
			},

			//图片上传之前
			beforeUpload(file) {
				// return new Promise((resolve, reject) => {
				// 	let reader = new FileReader()
				// 	reader.readAsDataURL(file)
				// 	reader.onload = () => {
				// 		let img = new Image()
				// 		img.src = reader.result
				// 		img.onload = () => {
				// 			if (img.naturalWidth / img.naturalHeight != 16 / 9) {
				// 				this.$message.error(`请上传宽高比为16:9的图片!`)
				// 				return reject(false)
				// 			} else {
				// 				return resolve(true)
				// 			}
				// 		}
				// 	}
				// })
			},
			//上传成功
			getPictrueURL(response, file, fileList) {
				this.info.themePic.push({
					url: response.data,
				});
				this.hideUpload = fileList.length >= 1;
			},
			// 款式主图预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 款式主图上传框删除一个图片
			handleRemove(file, fileList) {
				this.info.themePic = [];
				this.hideUpload = false;
			},
			// 款式主图预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
		},
		created() {
			this.getInfo1();
			this.getInfo2();
			this.getLevel()
		},
	};
</script>

<style scoped="scoped">
	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>